


































import { Component, Vue, Watch } from 'vue-property-decorator'
// import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { Page } from '@/interfaces'
import store from '@/store'

@Component({
  components: {
    PageHead,
  },
})
export default class PageEdit extends Vue {
  pageTitle = 'Edit robots.txt'
  callInProgress = false
  robots_content = null
  urlScheme = window.location.protocol
  domain = window.location.hostname.replace(/www./i, '')

  created() {
    this.fetchDomainRobotsTxt()
  }

  @Watch('$route.params.id')
  onVariable() {
    this.fetchDomainRobotsTxt()
  }

  public async fetchDomainRobotsTxt() {
    this.callInProgress = true
    try {
      const domainRobotsTxtResponse = await Api.getDomainRobotsTxt(parseInt(this.$route.params.id))
      this.robots_content = domainRobotsTxtResponse.robots_content
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async saveChanges() {
    if (!this.robots_content) {
      Notify.create({
        type: 'error',
        title: 'Required Data',
        text: 'Content for robots.txt is required!',
      })
      return false
    }

    this.callInProgress = true
    try {
      await Api.updateDomainRobotsTxt(this.domain, this.robots_content)
      this.callInProgress = false
      store.commit('toggleFlag', 'reloadNav')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Content for robots.txt updated!',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
